import { Input } from "@/ui/input";
import { Label } from "@/ui/label";
import { cn } from "@/lib/utils";

/** Một ô chữ của khối hoá đơn — nhãn, lỗi đỏ, dòng phụ. Dùng chung cho bốn ô
 *  doanh nghiệp (BookingInvoiceSection) và các ô người mua cá nhân
 *  (PersonalBuyerFields). */
export function InvoiceField({
  id,
  label,
  value,
  onChange,
  error,
  hint,
  className,
  ...rest
}: {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string | undefined;
  /** Dòng phụ dưới ô (vd kết quả tra mã số thuế). Không phải lỗi, không tô đỏ. */
  hint?: React.ReactNode;
  className?: string;
  placeholder?: string;
  type?: string;
  inputMode?: "numeric";
  autoComplete?: string;
  maxLength?: number;
  disabled?: boolean | undefined;
}) {
  const errorId = `${id}-error`;
  return (
    <div className={cn("space-y-1.5", className)}>
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        className="min-h-11"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? errorId : undefined}
        {...rest}
      />
      {error && (
        <p id={errorId} className="text-xs text-danger-text">
          {error}
        </p>
      )}
      {hint}
    </div>
  );
}
